import { setFileList } from '../State/fileList';

export default (file) => (dispatch, getState) => {
  
  const { fileList } = getState().modals.EmailProjectInformation;

  const newFileList = [ ...fileList, file ];

  dispatch(setFileList(newFileList));

  return false;

}